import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../API/apiClient ';
import { decryptUserInfo } from '../../SharedFiles/decryption/Decryption'; 

// Async thunk for logging in
export const loginUser = createAsyncThunk('login/loginUser', async (credentials, { rejectWithValue }) => {
  try {
    const response = await apiClient.post('UserLogin/Login', credentials); 
    // Decrypt the encrypted response data
    const decryptedUserInfo = decryptUserInfo(response.data);    
    return response.data; // Return the decrypted user data and token
  } catch (error) {
    console.error('Login error:', error);
    return rejectWithValue(error.response?.data?.message || 'Invalid username or password'); // Return the error message
  }
});
